__turbopack_context__.v({
  "actions": "photoStudio-module__7R_osa__actions",
  "compareToggle": "photoStudio-module__7R_osa__compareToggle",
  "comparisons": "photoStudio-module__7R_osa__comparisons",
  "controlIntro": "photoStudio-module__7R_osa__controlIntro",
  "controls": "photoStudio-module__7R_osa__controls",
  "disclaimer": "photoStudio-module__7R_osa__disclaimer",
  "error": "photoStudio-module__7R_osa__error",
  "eyebrow": "photoStudio-module__7R_osa__eyebrow",
  "file": "photoStudio-module__7R_osa__file",
  "filters": "photoStudio-module__7R_osa__filters",
  "intro": "photoStudio-module__7R_osa__intro",
  "loading": "photoStudio-module__7R_osa__loading",
  "next": "photoStudio-module__7R_osa__next",
  "oliveGrid": "photoStudio-module__7R_osa__oliveGrid",
  "oliveGuide": "photoStudio-module__7R_osa__oliveGuide",
  "oliveSwatch": "photoStudio-module__7R_osa__oliveSwatch",
  "photo": "photoStudio-module__7R_osa__photo",
  "photoActions": "photoStudio-module__7R_osa__photoActions",
  "photoLabels": "photoStudio-module__7R_osa__photoLabels",
  "preview": "photoStudio-module__7R_osa__preview",
  "primary": "photoStudio-module__7R_osa__primary",
  "privacy": "photoStudio-module__7R_osa__privacy",
  "range": "photoStudio-module__7R_osa__range",
  "rangeEnds": "photoStudio-module__7R_osa__rangeEnds",
  "saved": "photoStudio-module__7R_osa__saved",
  "sectionHeading": "photoStudio-module__7R_osa__sectionHeading",
  "selection": "photoStudio-module__7R_osa__selection",
  "spin": "photoStudio-module__7R_osa__spin",
  "spinner": "photoStudio-module__7R_osa__spinner",
  "status": "photoStudio-module__7R_osa__status",
  "studio": "photoStudio-module__7R_osa__studio",
  "swatches": "photoStudio-module__7R_osa__swatches",
  "textButton": "photoStudio-module__7R_osa__textButton",
  "upload": "photoStudio-module__7R_osa__upload",
  "visual": "photoStudio-module__7R_osa__visual",
  "workspace": "photoStudio-module__7R_osa__workspace",
});
